<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dMh2uH/tc-custom/9781504091589.jpg?1718160607545" alt="This image is the cover for the book Interrogation"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Interrogation
      </h1>
      <p class="bookDescription body article font2">
        <b>Everyone has a breaking point . . . “Probably no other suspense writer takes readers as deeply into the heart of darkness as Cook.” —<i>Chicago Tribune</i></b><br/><br/>There are no witnesses nor evidence to link him to the crime, but the police are sure that vagrant Albert Jay Smalls killed a child. Their interviews have led nowhere, but now—with a 6:00 a.m. deadline looming at which he must be released from custody—they will try one more interrogation. Detective Pierce, whose own daughter’s death has left a hole in his heart, and Detective Cohen, still broken from what he saw in World War II, will look into the abyss of Smalls’s troubled mind in a frantic last-ditch effort to extract a confession. Their effort will bring answers they never expected—and blur the line between innocence and guilt . . .<br/><br/>“Cook adroitly weaves back and forth between the crime itself, the subsequent investigation and the halting questioning of the suspect. More compelling, however, is his portrayal of how the crime affects Pierce and Cohen, as well as several secondary characters . . . Down to the cleverly hatched, melancholy ending, Cook again takes readers down a dark, treacherous road into the heart of human fallibility and struggle.” —<i>Publishers Weekly</i><br/><br/>“[An] irresistible premise.” —<i>Kirkus Reviews</i><br/><br/>“Well-plotted . . . The psychic pain of these characters is piercing.” —<i>The New York Times Book Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas H. Cook
      </h2>
      
      <p class="authorDescription body article"> THOMAS H. COOK was born in Fort Payne, Alabama. He has been nominated for Edgar Awards seven times in five different categories. He received the Best Novel Edgar, the Barry for Best Novel, and has been nominated for numerous other awards.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1f2de95d